export const PASSWORD_GROUPS = {
  lower: 'abcdefghijklmnopqrstuvwxyz',
  upper: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  digits: '0123456789',
  symbols: '!@#$%&*+-_=?:.',
};

// Rejection sampling avoids bias when the alphabet does not divide 2^32.
function randomIndex(max) {
  if (!window.crypto?.getRandomValues) {
    throw new Error('La génération sécurisée est indisponible dans ce navigateur.');
  }
  const limit = Math.floor(0x100000000 / max) * max;
  const buffer = new Uint32Array(1);
  do { window.crypto.getRandomValues(buffer); } while (buffer[0] >= limit);
  return buffer[0] % max;
}

export function generatePassword(length, options) {
  if (!Number.isInteger(length) || length < 12 || length > 64) {
    throw new Error('Choisissez une longueur entre 12 et 64 caractères.');
  }
  const groups = Object.entries(PASSWORD_GROUPS)
    .filter(([key]) => options[key])
    .map(([,chars]) => options.excludeSimilar ? chars.replace(/[Il1O0o]/g, '') : chars);
  if (!groups.length) throw new Error('Sélectionnez au moins un type de caractères.');
  const alphabet = groups.join('');
  const chars = groups.map(group => group[randomIndex(group.length)]);
  while (chars.length < length) chars.push(alphabet[randomIndex(alphabet.length)]);
  // Shuffle the guaranteed characters along with the rest of the password.
  for (let i = chars.length - 1; i > 0; i--) {
    const j = randomIndex(i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
}

